import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { Session } from "@/types/session";

export function useSession() {
  return useQuery({
    queryKey: ["session"],
    queryFn: () => api.get<Session>("/api/session"),
    staleTime: 5 * 60_000,
  });
}
